import React from "react";
import { STATISTICS_WIDGET_RESOURCE_TYPE } from "@constants";
import LoadableVideoDetail from "@routes/asset/ui/detail/LoadableVideoDetail";
import LoadableCaptionDetail from "@routes/asset/ui/detail/LoadableCaptionDetail";
import LoadableEtcFileDetail from "@routes/asset/ui/detail/LoadableEtcFileDetail";
import SelectMultiImage from "@routes/asset/ui/select-multi-image";
import { Grid, Typography } from "@mzc-pdc/ui";
import theme from "@styles/theme";
import { alpha } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ImageDefaultFileDark } from "@mzc-cloudplex/icons";
import SelectMultiCaption from "@routes/asset/ui/select-multi-caption";
import { TimelineProvider } from "@hooks/timeline";

const PreviewAsset = ({ data, mediaType, onChange }) => {
    const { t } = useTranslation();
    return {
        IMAGE: <SelectMultiImage data={data} onChange={onChange} />,
        VIDEO: (
            <TimelineProvider>
                <LoadableVideoDetail
                    {...data}
                    statisticsType={STATISTICS_WIDGET_RESOURCE_TYPE.ASSET}
                    isShowRendition={false}
                    isShowStatistics={false}
                    resourceType={"ASSET"}
                    onChangeOwner={() => {}}
                    isDisabled={true}
                    setAnalyzableAsset={() => {}}
                    setOutputStorage={() => {}}
                    videoPlayerHeight={252}
                />
            </TimelineProvider>
        ),
        AUDIO: (
            <LoadableVideoDetail
                {...data}
                statisticsType={STATISTICS_WIDGET_RESOURCE_TYPE.ASSET}
                isShowRendition={false}
                isShowStatistics={false}
                resourceType={"ASSET"}
                onChangeOwner={() => {}}
                isDisabled={true}
            />
        ),
        TEXT: <SelectMultiCaption data={data} onChange={onChange} />,
        CAPTION: <SelectMultiCaption data={data} onChange={onChange} />,
        FILE: (
            <Grid container gap={1}>
                <Grid
                    container
                    flexDirection={"row"}
                    sx={{
                        height: 320,
                        p: 2,
                        overflowY: "auto",
                        backgroundColor: alpha(theme.palette.greySecondary[50], 0.5),
                        borderRadius: theme.spacing(1),
                        gap: "12px",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <Grid item>
                        <ImageDefaultFileDark width={46} height={56} />
                    </Grid>
                </Grid>
            </Grid>
        ),
    }[mediaType];
};

export default PreviewAsset;
